import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import { LoaderContext } from "./Helpers/Context/Context";
import Loader from "./Helpers/Loader/Loader";
import Router from "./Routes/router";
import { isDev } from "./Helpers/Common";
import ConnCheck from "./Components/ConnCheck/ConnCheck";

//force build_20240926_145251
function App() {
  const [loader, setLoader] = useState<boolean>(false);
  const showLoader = () => setLoader(true);
  const hideLoader = () => setLoader(false);

  const [asidebar, setAsidebar] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const secret = "secret";

  const mobileResMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const [rte, setRte] = useState(null);

  

  return (
    <>
      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        <Router />
        {/* <div className="menubar-hoverable header-fixed">
          <Header
            menuOpenFunc={mobileResMenu}
            setAsidebar={setAsidebar}
            aisebar={asidebar}
          />
          <div id="base">
            <div id="content">
              <div className="main-content">
                <Routes>
                  <Route path="/" element={<GridStructure />} />
                  <Route path="/profile" element={<FormStructure />} />
                  <Route path="/login" element={<Login />} />
                </Routes>
              </div>
            </div>
            <Sidebar menuOpen={menuOpen} />
            <Footer />
          </div>
        </div> */}
        {/* <ConnCheck /> */}
        <ToastContainer
          position="top-center"
          autoClose={false}
          hideProgressBar={true}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          icon={true}
          pauseOnHover
        />
        {loader && <Loader />}
      </LoaderContext.Provider>
    </>
  );
}

export default App;
